module.exports = __webpack_public_path__ + "e74b63513b10b7ce62bcef06337c2c57.gif";